'use strict';

require('url-search-params-polyfill');

const TrackJS = require('jiji/infra/trackjs');

const Mn = require('backbone.marionette');

// const I18next = require('i18next');
// const XHR = require('i18next-xhr-backend');

const Router = require('jiji/app/router/index');
const HeaderView = require('jiji/ui/view/header/index');
const LoginView = require('jiji/ui/view/content/login/index');
const UserView = require('jiji/ui/view/content/user/index');
const SignupView = require('jiji/ui/view/content/signup/index');
const ConnectView = require('jiji/ui/view/content/connect/index');
const AdminHeaderView = require('jiji/ui/view/header/admin/index');
const AdminView = require('jiji/ui/view/content/admin/index');
const AdminOauthView = require('jiji/ui/view/content/admin/oauth/index');
const ErrorView = require('jiji/ui/view/error');
const UserRepository = require('jiji/domain/repository/user');

/**
 * App Engine のデフォルトドメインにアクセスされた際に、独自ドメインに fallback させる
 */
if (window && window.location) {
    const hostname = window.location.hostname;
    const href= window.location.href;

    if (hostname === 'jiji-dev.an.r.appspot.com') {
        window.location.href = href.replace('jiji-dev.an.r.appspot.com', 'jiji-dev.appspot.com');
    }

    if (hostname === 'jiji-stage.an.r.appspot.com') {
        window.location.href = href.replace('jiji-stage.an.r.appspot.com', 'jiji-stage.appspot.com');
    }

    if (hostname === 'jiji-app.an.r.appspot.com') {
        window.location.href = href.replace('jiji-app.an.r.appspot.com', 'jiji-app.appspot.com');
    }
}

const app = new Mn.Application({
    region: 'body',
    onStart: function() {
        const rootView = new (Mn.View.extend({
            el: '#root',
            regions: {
                header: '#header-wrapper',
                content: '#content-wrapper'
            }
        }))();
        this.showView(rootView);

        Router.on('header', () => {
            UserRepository.getLoginUser()
                .then(user => {
                    if (user && user.id) {
                        TrackJS.addMetadata('name', user.get('name'));
                    }

                    rootView.showChildView('header', new HeaderView({model: user}));

                    if (location.href.indexOf('hasError') >= 0) {
                        foo.barbaz; // サンプルのエラー
                    }
                });
        });
        Router.on('admin:header', () => {
            rootView.showChildView('header', new AdminHeaderView());
        });

        const setTitle = function(title) {
            document.title = title;
            $('title').text(title);
        };

        Router.on('all', () => {
            // GA.viewPage();
        });

        Router.on('user', () => {
            setTitle('Home');
            UserRepository.getLoginUser()
                .then(user => {
                    if(!user || !user.id) {
                        Router.navigate('login', {trigger: true});
                    } else {
                        // Mixpanel.track('User:View', {uid: user.id});
                        rootView.showChildView('content', new UserView({model: user}));
                    }
                });
        });

        Router.on('login', () => {
            rootView.showChildView('content', new LoginView());
        });

        Router.on('signup', () => {
            rootView.showChildView('content', new SignupView());
        });

        Router.on('connect', () => {
            rootView.showChildView('content', new ConnectView());
        });

        Router.on('admin', () => {
            rootView.showChildView('content', new AdminView());

        });
        Router.on('admin:oauth', () => {
            rootView.showChildView('content', new AdminOauthView());
        });

        Backbone.history.start({pushState: true, root: '/'});
    }
});


app.start();



// WEBPACK FOOTER //
// ./jiji/ui/view/index.js